<template>
  <div class="block-cell">
    <p class="block-cell-title">
      <span>{{ title }}</span>
      <img v-if="isTip" @click="tipClick" :src="helpBlue" />
    </p>
    <p class="block-cell-value">
      {{ value }}
    </p>
  </div>
</template>
<script>
/* eslint-disable */
import { Help_Blue } from '@/images/myCard'
import mixins from '@/utils/mixins'
/* eslint-enable */
export default {
  mixins: [mixins],
  props: {
    width: {
      type: String,
      default: '345'
    },
    title: {
      type: String,
      default: '預計每期應交款'
    },
    value: {
      type: [String, Number],
      default: 'HKD 200,000.00'
    },
    isTip: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      helpBlue: Help_Blue
    }
  },
  // computed: {
  //   blockcell () {
  //     const style = {}
  //     this.$nextTick(() => {
  //       style.width = `${this.pxGo(this.width)}px`
  //     })
  //     return style
  //   }
  // },
  methods: {
    tipClick () {
      this.$emit('tipClick')
    }
  }
}
</script>

<style lang="scss" scoped>
.block-cell {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  box-sizing: border-box;
  // width: 345px;
  width: 100%;
  padding: 4px 0;
  background-color: $color-bg-white;
  p {
    font-size: $span-font-size;
    line-height: 20px;
    word-wrap: break-word;
  }
  p.block-cell-title {
    box-sizing: border-box;
    width: 140px;
    color: $color-stage4;
    text-align: left;
    img {
      width: 16px;
      height: 16px;
      vertical-align: text-top;
      transform: translateY(2px);
    }
  }
  p.block-cell-value {
    width: 190px;
    color: $color-text;
    text-align: right;
  }
}
</style>
